<template>
  <section class="my-cards-view">
    <FloatingHeader title="Meus Cartões" sbtitle="Gerencie seus cartões" :showHeader="true" :hideSearch="true"
      :routeToBack="'profile'"></FloatingHeader>

    <div class="cards-container" id="cards-container">
      <div class="icon">
        <fa icon="plus" size="2x" @click="handleCardMenuVisibility"></fa>
      </div>
      <div class="list" v-if="cardAdditionMenu.isVisible">
        <div class="card-item">
          <img :src="cardImage">
          <div>
            <span class="expiration" v-text="getExpirationAsDate(newCardValues.validade)"></span>
            <img class="flag" :src="getCardFlag(newCardValues.flag)" />
            <span class="number">{{ newCardValues.numerodocartao }}</span>
            <span class="name" v-text="newCardValues.nomedotitular"></span>
          </div>
        </div>
      </div>

      <div class="list" v-if="userCardList && userCardList.length">
        <div class="card-item" v-for="(card, key) in userCardList" :key="key" @click="selectCard(card)">
          <img :src="cardImage">
          <template v-for="(cardDet, cdetkey) in ['number', 'name', 'expiration', 'flag']" :key="cdetkey">
            <span :class="cardDet" v-if="cardDet == 'expiration'" v-text="getExpirationAsDate(card[cardDet])"></span>
            <img :class="cardDet" v-else-if="cardDet == 'flag'" :src="getCardFlag(card[cardDet])" />
            <span :class="cardDet" v-else-if="cardDet == 'number'" v-text="'XXXX XXXX XXXX ' + card[cardDet]"></span>
            <span :class="cardDet" v-else v-text="card[cardDet]"></span>
          </template>
        </div>
      </div>
      <div v-else-if="(!userCardList || userCardList.length === 0) && !isLoading">
        <span class="not-found">Não foram encontrados cartões associados a está conta!</span>
      </div>
    </div>

    <CardAdditionComponent @addCard="addCard" v-if="cardAdditionMenu.isVisible" :isEmptyCardList="userCardList.length === 0" @closeMenu="handleCardMenuVisibility" />
    <DeleteItemComponent :itemName="'Deletar Cartão'" @deleteEvent="deleteCard" @closeMenu="handleDeleteMenuVisibility" />
    <ModalInfo @actionTrue="confirmDeletion" @actionFalse="closeModalInfo" />
    <ScreenLoader :isLoading="isLoading"></ScreenLoader>
  </section>
</template>

<script>
import FloatingHeader from '@/components/FloatingHeader.vue'
import { registerNewCard, deleteCreditCard, getUserCards } from '@/assets/controllers/CardsController'
import CardAdditionComponent from '@/components/bottom-popups/CardAdditionComponent.vue'
import DeleteItemComponent from '@/components/bottom-popups/DeleteItemComponent.vue'
import ModalInfo from '@/components/modals/ModalInfo.vue'
import ScreenLoader from '@/components/loader/ScreenLoader.vue'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import Util from '@/assets/libs/util'

export default {
  name: 'MyCardsView',
  components: {
    FloatingHeader,
    CardAdditionComponent,
    DeleteItemComponent,
    ModalInfo,
    ScreenLoader
  },
  data () {
    return {
      fields: ['Final', 'Nome', 'Validade', 'Bandeira'],
      selectedCard: null,
      isSorted: false,
      cardImage: require('@/assets/img/card.png'),
      isLoading: false
    }
  },
  computed: {
    ...mapGetters(['userCardList', 'newCardValues', 'cardAdditionMenu', 'deleteItemMenu'])
  },
  methods: {
    ...mapActions(['changeCardAdditionMenuVisibility', 'changeDeleteItemVisibility', 'showModalInfo', 'closeModalInfo', 'clearNewCardValues', 'deleteCardMock', 'pushCardMock']),
    selectCard: function (card) {
      this.selectedCard = card
      this.changeDeleteItemVisibility()
      document.body.style.overflow = 'hidden'
    },
    getCardFlag: function (flag) {
      try {
        if (flag && flag.length > 2) {
          const flagName = Util.getFlagName(flag)
          return require('@/assets/icons/cardflags/' + flagName + '.svg')
        }
        return ''
      } catch (error) {
        return ''
      }
    },
    getExpirationAsDate: function (date) {
      if (!date) {
        return ''
      }
      let expirationDate = moment(date, 'MM/YY')
      if (expirationDate.isValid()) {
        return expirationDate.format('MM/YY')
      }
      expirationDate = moment(date)
      if (expirationDate.isValid()) {
        return expirationDate.format('MM/YY')
      }
      return 'Data inválida'
    },
    handleCardMenuVisibility: function () {
      // prevents the body from scrolling when the menu is open
      this.changeCardAdditionMenuVisibility()
      document.body.style.overflow = this.cardAdditionMenu.isVisible ? 'hidden' : 'auto'
    },
    handleDeleteMenuVisibility: function () {
      document.body.style.overflow = this.deleteItemMenu.isVisible ? 'hidden' : 'auto'
    },
    addCard: async function () {
      this.isLoading = true
      const result = await registerNewCard()
      if (result && !result.error) {
        this.showModalInfo({ type: 'success', text: 'Cartão cadastrado com sucesso', open: true })
        this.clearNewCardValues()
        this.changeCardAdditionMenuVisibility()
      } else {
        this.changeCardAdditionMenuVisibility()
      }
      this.isLoading = false
      document.body.style.overflow = 'auto'
    },
    deleteCard: function (ev) {
      this.showModalInfo(
        {
          type: 'defaultDialog',
          text: `Deseja deletar o cartão com final ${this.selectedCard.number}?`,
          open: true
        }
      )
      this.changeDeleteItemVisibility()
      document.body.style.overflow = 'auto'
    },
    confirmDeletion: async function () {
      this.closeModalInfo()
      this.isLoading = true
      await deleteCreditCard(this.selectedCard)
      this.isLoading = false
    }
  },
  mounted () {
    this.isLoading = true
    getUserCards().then(() => {
      this.isLoading = false
    }).catch(() => {
      this.isLoading = false
    })
  }
}
</script>

<style lang="less" scoped>
.my-cards-view {
  position: relative;
  display: block;
  padding: 75px 20px 140px 20px;

  .not-found {
    position: relative;
    display: block;
    text-align: center;
    background: rgba(0, 0, 0, .06);
    padding: 15px 0;
  }

  .cards-container {
    position: relative;
    display: block;
    overflow: auto;

    .icon {
      background-color: var(--primaryColor);
      position: fixed;
      bottom: 10%;
      right: 5%;
      display: flex;
      color: white;
      z-index: 1;
      border-radius: 10%;
      padding: 5px;
    }

    .card-item {
      position: relative;
      display: table;
      max-width: 345px;
      margin: 20px 0;

      img {
        display: block;
        max-width: 100%;

        &.flag {
          position: absolute;
          bottom: 20%;
          width: 80px;
          right: 5%;
          border-radius: 10px;
        }
      }

      span {
        position: absolute;
        // font-weight: bold;
        text-align: center;
        color: white;
        font-size: 14px;

        &.name {
          bottom: 35%;
          left: 5%;
          width: 200px;
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &.number {
          left: 5%;
          bottom: 23%;
          width: 200px;
          text-align: left;
        }

        &.expiration {
          bottom: 10%;
          left: 5%;
        }
      }
    }

  }
}

// media
@media (max-width: 375px) {
  .cards-container {
    .list-fields {
      grid-template-columns: 1fr 1fr;
      word-break: break-word;
    }

    .list-item {
      grid-template-columns: 1fr 1fr;
    }
  }
}
</style>
